import React from 'react';

import Link from '../Link/Link';

import './ImageThumbnail.scss';
import { ImageDispatcher } from '../ImageDispatcher/ImageDispatcher';

const ImageThumbnail = ({ image, url, uiVariant, onClick, lazy, name }) => {
  const handleOnClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return (
    <div className="image-thumbnail">
      <Link to={url} onClick={handleOnClick}>
        <ImageDispatcher
          alt={`Prodotti per ${name}`}
          className={`image-container ${lazy ? 'lazyload' : ''}`}
          src={image}
          style={{
            borderRadius: uiVariant === '1' ? 12 : 0,
            width: '100%',
            objectFit: 'cover',
          }}
        />
      </Link>
    </div>
  );
};

export default ImageThumbnail;
